import React from "react";
import CarouselDesk from "../../mui/carousel_desk/CarouselDesk";
import "./providers.scss";

import { useSelector } from "react-redux";
import ShowContainer from "../../mui/ShowContainer";
import useGetItems from "../../../hooks/other/useGetItems";
import ProviderItem from "./provider_item/ProviderItem";

export default function Providers() {
  const providers = useSelector((state) => state.games.providers);
  const checkNoEmptyList = Array.isArray(providers) && providers.length;

  const slidesToShow = useGetItems();
  const isRow2 = providers.length > slidesToShow * 2 - 1;
  const GameRowClass = isRow2 ? "games-rows-2" : "games-rows";

  const getGameItems = () => {
    if (!isRow2) return providers.map((el) => ({ item1: el }));

    const res = [];
    let curItem = {
      item1: undefined,
      item2: undefined
    };

    providers.forEach((el, indx) => {
      indx % 2 ? (curItem.item1 = el) : (curItem.item2 = el);

      if (curItem.item1 && curItem.item2) {
        res.push(curItem);
        curItem = {};
      }
    });
    return res;
  };

  const providersItems = getGameItems();

  return (
    <ShowContainer condition={checkNoEmptyList}>
      <section className="providers">
        <div className="providers__content">
          <CarouselDesk
            id={"providers"}
            showAllLink="/games/providers"
            title={"Providers"}
            items={providersItems}
            row2={isRow2}>
            {providersItems.map((el, indx) => {
              const item1 = el.item1;
              const item2 = el.item2;
              return (
                <div key={el.id || indx} className={GameRowClass}>
                  <ProviderItem key={indx} el={item1} />

                  <ShowContainer condition={!!item2}>
                    <ProviderItem key={indx} el={item2} />
                  </ShowContainer>
                </div>
              );
            })}
          </CarouselDesk>
        </div>
      </section>
    </ShowContainer>
  );
}
